import type { GameDef, SceneDef } from "../genesis/schema";

import parcoursDuDisciple from "./scenes/parcoursDuDisciple";
import parcoursDuDiscipleScene2 from "./scenes/parcoursDuDiscipleScene2";
import parcoursDuDiscipleScene3 from "./scenes/parcoursDuDiscipleScene3";
import parcoursDuDiscipleScene4 from "./scenes/parcoursDuDiscipleScene4";
import archeDeNoe from "./scenes/archeDeNoe";
import archeDeNoeScene2 from "./scenes/archeDeNoeScene2";
import archeDeNoeScene3 from "./scenes/archeDeNoeScene3";
import archeDeNoeScene4 from "./scenes/archeDeNoeScene4";
import relaisHerosDeLaFoi from "./scenes/relaisHerosDeLaFoi";
import relaisHerosDeLaFoiScene2 from "./scenes/relaisHerosDeLaFoiScene2";
import relaisHerosDeLaFoiScene3 from "./scenes/relaisHerosDeLaFoiScene3";
import relaisHerosDeLaFoiScene4 from "./scenes/relaisHerosDeLaFoiScene4";
import vieDeJesus from "./scenes/vieDeJesus";
import vieDeJesusScene2 from "./scenes/vieDeJesusScene2";
import vieDeJesusScene3 from "./scenes/vieDeJesusScene3";
import vieDeJesusScene4 from "./scenes/vieDeJesusScene4";
import voyagesDePaul from "./scenes/voyagesDePaul";
import voyagesDePaulScene2 from "./scenes/voyagesDePaulScene2";
import voyagesDePaulScene3 from "./scenes/voyagesDePaulScene3";
import voyagesDePaulScene4 from "./scenes/voyagesDePaulScene4";
import vieDimpact from "./scenes/vieDimpact";
import vieDimpactScene2 from "./scenes/vieDimpactScene2";
import vieDimpactScene3 from "./scenes/vieDimpactScene3";
import vieDimpactScene4 from "./scenes/vieDimpactScene4";
import filsProdigue from "./scenes/filsProdigue";
import filsProdigueScene2 from "./scenes/filsProdigueScene2";
import filsProdigueScene3 from "./scenes/filsProdigueScene3";
import filsProdigueScene4 from "./scenes/filsProdigueScene4";
import actesDesApotres from "./scenes/actesDesApotres";
import actesDesApotresScene2 from "./scenes/actesDesApotresScene2";
import actesDesApotresScene3 from "./scenes/actesDesApotresScene3";
import actesDesApotresScene4 from "./scenes/actesDesApotresScene4";
import lesEvangiles from "./scenes/lesEvangiles";
import lesEvangilesScene2 from "./scenes/lesEvangilesScene2";
import lesEvangilesScene3 from "./scenes/lesEvangilesScene3";
import lesEvangilesScene4 from "./scenes/lesEvangilesScene4";
import beniPourBenir from "./scenes/beniPourBenir";
import beniPourBenirScene2 from "./scenes/beniPourBenirScene2";
import beniPourBenirScene3 from "./scenes/beniPourBenirScene3";
import beniPourBenirScene4 from "./scenes/beniPourBenirScene4";
import armesDuChretien from "./scenes/armesDuChretien";
import armesDuChretienScene2 from "./scenes/armesDuChretienScene2";
import armesDuChretienScene3 from "./scenes/armesDuChretienScene3";
import armesDuChretienScene4 from "./scenes/armesDuChretienScene4";
import bonCombat from "./scenes/bonCombat";
import bonCombatScene2 from "./scenes/bonCombatScene2";
import bonCombatScene3 from "./scenes/bonCombatScene3";
import bonCombatScene4 from "./scenes/bonCombatScene4";
import lePere from "./scenes/lePere";
import lePereScene2 from "./scenes/lePereScene2";
import lePereScene3 from "./scenes/lePereScene3";
import lePereScene4 from "./scenes/lePereScene4";
import vraisAdorateurs from "./scenes/vraisAdorateurs";
import vraisAdorateursScene2 from "./scenes/vraisAdorateursScene2";
import vraisAdorateursScene3 from "./scenes/vraisAdorateursScene3";
import vraisAdorateursScene4 from "./scenes/vraisAdorateursScene4";
import apocalypse from "./scenes/apocalypse";
import apocalypseScene2 from "./scenes/apocalypseScene2";
import apocalypseScene3 from "./scenes/apocalypseScene3";
import apocalypseScene4 from "./scenes/apocalypseScene4";

/** Scene chains per game (main scene + wave-3 parcours scenes, play order). */
const CHAINS: SceneDef[][] = [
  [parcoursDuDisciple, parcoursDuDiscipleScene2, parcoursDuDiscipleScene3, parcoursDuDiscipleScene4],
  [archeDeNoe, archeDeNoeScene2, archeDeNoeScene3, archeDeNoeScene4],
  [relaisHerosDeLaFoi, relaisHerosDeLaFoiScene2, relaisHerosDeLaFoiScene3, relaisHerosDeLaFoiScene4],
  [vieDeJesus, vieDeJesusScene2, vieDeJesusScene3, vieDeJesusScene4],
  [voyagesDePaul, voyagesDePaulScene2, voyagesDePaulScene3, voyagesDePaulScene4],
  [vieDimpact, vieDimpactScene2, vieDimpactScene3, vieDimpactScene4],
  [filsProdigue, filsProdigueScene2, filsProdigueScene3, filsProdigueScene4],
  [actesDesApotres, actesDesApotresScene2, actesDesApotresScene3, actesDesApotresScene4],
  [lesEvangiles, lesEvangilesScene2, lesEvangilesScene3, lesEvangilesScene4],
  [beniPourBenir, beniPourBenirScene2, beniPourBenirScene3, beniPourBenirScene4],
  [armesDuChretien, armesDuChretienScene2, armesDuChretienScene3, armesDuChretienScene4],
  [bonCombat, bonCombatScene2, bonCombatScene3, bonCombatScene4],
  [lePere, lePereScene2, lePereScene3, lePereScene4],
  [vraisAdorateurs, vraisAdorateursScene2, vraisAdorateursScene3, vraisAdorateursScene4],
  [apocalypse, apocalypseScene2, apocalypseScene3, apocalypseScene4],
];

/** The 15 games ("Les Cles du Royaume"), ordered, each with its full parcours.
 *  CHAINS keeps the authored play order [main, s2, s3, s4] — scene `order`
 *  fields are NOT comparable across waves (main uses game index, s2-4 use 2-4),
 *  so the chain position is authoritative, and the CHAINS index is game order. */
export const GAMES: GameDef[] = CHAINS.map((scenes, i) => {
  const main = scenes[0];
  return { slug: main.game, title: main.title, order: i + 1, scenes };
});

export function firstScene(slug: string): SceneDef | undefined {
  return GAMES.find((g) => g.slug === slug)?.scenes[0];
}
